// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ok-0";